export default "/assets/images/the-home-wrecker.9d1a52269b98228e.jpg";